import {ContentSet, RemoteContentSet} from './contentSets.types';
import {DateTime} from 'luxon';

export function toClientContentSet(remoteContentSet: RemoteContentSet): ContentSet {
  return {
    ...remoteContentSet,
    ...(remoteContentSet.lastPopulationDate
      ? {
          lastPopulationDate: DateTime.fromISO(remoteContentSet.lastPopulationDate),
        }
      : {
          lastPopulationDate: undefined,
        }),
  };
}
